import react, { useEffect, useRef, useState } from "react";
import Box from "@mui/material/Box";
import { DataGrid, GridColDef, GridToolbarColumnsButton, GridToolbarContainer, GridToolbarDensitySelector, GridToolbarExport, GridToolbarFilterButton, GridValueGetterParams, getGridStringOperators, } from "@mui/x-data-grid";
import styled from "styled-components";
import CloseIcon from '@mui/icons-material/Close';
import Drawer from "../../components/common/drawer/drawer";
import { Typography, Button, Checkbox, Fab, InputLabel, FormControl, IconButton, Stack, Select, MenuItem, Modal, Dialog, DialogActions, DialogContent, DialogTitle, Autocomplete, TextField, Tab, Tabs, Paper } from "@mui/material";
import Tooltip from "@mui/material/Tooltip";
import { ERROR_COLOR } from "../../constants";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import todayCalanerImage from "../../icons/todaysCalander.svg"
import { Add, Save, SaveAlt } from "@mui/icons-material";
import WarehouseModal from "../../components/modals/orderLineItemModal";
import OpaqueLoading from "../../components/opaqueLoading/opaqueLoading";
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import AttendanceModal from "../../components/modals/attendanceModal";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import * as XLSX from "xlsx";
import axios from "axios";
import TodayPunchModal from "../../components/modals/TodayPunchModal";
import clearFilterImage from "../../../src/icons/clearFilter.svg"
import searchIcon from "../../icons/searchIcon.svg"
import { set } from "date-fns";
const isMobile = window.innerWidth < 900;
const StaffEditorPageContainer = styled.div`
  height: "calc(100vh - 105px)";
  width: 100%;
  background-color: white;
  padding: 10px 15px;
`;
const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: "space-between";
  margin-bottom: 10px;
  flex-direction: "row";
`;

const TableContainer = styled.div`
  width: 100%;
  // border: solid 1px lightGrey;
  border-radius: 8px;
`;
const AvatarContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;
const TabsContainer = styled.div`
  ${isMobile &&
  `
    height: calc(100vh - 56px - 20px - 43.77px);
  `}
`;
const StyledTabs = styled(Tabs)`
  border-bottom: solid 1px lightGrey;
`;
const DataGridContainer = styled.div`
  max-width: 100%; /* Add this line to limit the width */
  margin: 0 auto; /* Center the content horizontally */
  height: 100%;
  width: 100%;
  border: solid 1px lightGrey;
  border-radius: 8px;
  display: 'flex' ;
`;
const LoadingContainer = styled.div`
  height: calc(100% - 49px);
  display: flex;
  justify-content: center;
  align-items: center;
`;

const GenerateReportButton = styled(Button)`
  margin-right: 10px !important;
`;
const BulkChangePinCodeButton = styled(Button)`
  margin-right: 10px !important;
`;
const PinCodeChangeButtonContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;
const FabStyle = styled(Fab)`
  && {
    z-index: 1};
  }
`;
const StyledHeader = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;
export default function AttendanceManagement() {
  const apiRef = useRef();
  const label = { inputProps: { "aria-label": "Checkbox demo" } };
  const [loading, setLoading] = useState(false);
  const [accessChanges, setAccessChanges] = useState("");
  const [showWarehouseFormModal, setShowWarehouseFormModal] = useState();
  const [attendanceModal, setAttendanceModal] = useState(false)
  const [attendanceModal1, setAttendanceModal1] = useState(false)
  const [rowCount, setRowCount] = useState()
  const [currentPage, setCurrentPage] = useState(1);
  const [paginationModel, setPaginationModel] = useState({
    page: currentPage - 1,
    pageSize: 20,
  });
  const [accessModulesData, setAccessModulesData] = useState([]);
  const [modalData, setModalData] = useState([])
  const [dataGrid, setDataGrid] = useState([]);
  const [tabValue, setTabValue] = useState(0);
  const [filter, setFilter] = useState(false)
  const [searchTerm, setSearchTerm] = useState(null)
  const [startDate, setStartDate] = useState()
  const [endDate, setEndDate] = useState()
  const [dateRange1, setDateRange1] = useState(false)
  const [startDate1, setStartDate1] = useState()
  const [endDate1, setEndDate1] = useState()
  const [minDate, setMinDate] = useState()
  const [rm, setRm] = useState("")
  const [rsm, setRsm] = useState("")
  const [asm, setAsm] = useState("")
  const [rsms, setRsms] = useState([]);
  const [allUsers, setAllUsers] = useState([]);
  const [asms, setAsms] = useState([]);
  const [rms, setRms] = useState([]);
  const [userData, setUserData] = useState(JSON.parse(localStorage.getItem('storedUserData')).user)
  const [openModal, setOpenModal] = useState(false);
  const [viewVisitDetails, setViewVisitDetails] = useState({})
  const [attendanceDetailsByDate, setAttendanceDetailsByDate] = useState({})
  const [openDialog, setOpenDialog] = useState(false);
  const [imageModalOpen, setImageModalOpen] = useState(false);
  const [imageUrl, setImageUrl] = useState("");
  const [attendanceStatus, setAttendanceStatus] = useState("");
  const [attendanceStatusData, setAttendanceStatusData] = useState([])
  const [sessions, setSessions] = useState([]); // from API
  const [selectedSession, setSelectedSession] = useState("");
  const [isDateRangeDisabled, setIsDateRangeDisabled] = useState(false);
  const [isSessionDisabled, setIsSessionDisabled] = useState(false);
  const [filteredDate, setFilteredData] = useState({})

  useEffect(() => {
    fetchSessions();
  }, []);

  const fetchSessions = async () => {
    try {
      setLoading(true);
      const response = await window.Platform.database.getAllSessions();
      // if (response?.data) {
      //   setSessions(response.data);
      // }
      if (response?.status) {
        const filterdData1 = response?.data?.filter((ele, ind) => ele?.action == "active")
        setFilteredData(filterdData1[0])
      }
      else {
        window.NotificationUtils.showError("Something Went Wrong in session")
      }
    } catch (error) {
      console.error("Error fetching sessions:", error);
      window.NotificationUtils.showError("Failed to load sessions");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!startDate && !endDate) {
      setIsSessionDisabled(false);
    }
  }, [startDate, endDate]);


  useEffect(() => {
    // setLoading(true);
    if (dataGrid.length > 0) {
      setFilter(true);
      if (filter) {
        fetchVisits()
      }
    }

  }, [attendanceStatus, paginationModel.page, paginationModel.pageSize]);

  useEffect(() => {
    setDataGrid([]);
    setAccessChanges([]);
    setPaginationModel({ page: 0, pageSize: 20, })
    setRsm("");
    setAsm("");
    setRm("");
    setSelectedSession("");
    const yesterday = new Date();
    yesterday.setDate(yesterday.getDate() - 1);
    let formatted = yesterday.toISOString().split("T")[0];
    setStartDate(formatted);
    setEndDate(formatted);
  }, [tabValue]);

  // useEffect(() => {
  //   attendanceStatusDropdown()
  //   if (userData?.role.toLowerCase().includes('admin')) {
  //     getAllUsers()
  //   }
  //   if (userData?.role == 'rsm') {
  //     getUsers('rsm', userData?.id)
  //   }
  //   if (userData?.role == 'asm') {
  //     getUsers('asm', userData?.id)
  //   }
  // }, [])

  useEffect(() => {
    fetchAccessModules();
    if (userData?.role.toLowerCase().includes('admin')) {
      getAllUsers();
    }
    if (userData?.role === 'rsm') {
      getUsers('rsm', userData?.id);
    }
    if (userData?.role === 'asm') {
      getUsers('asm', userData?.id);
    }
    const yesterday = new Date();
    yesterday.setDate(yesterday.getDate() - 1);
    const formatted = yesterday.toISOString().split("T")[0];
    setStartDate(formatted);
    setEndDate(formatted);
  }, []);

  // useEffect(() => {
  //   if (startDate && endDate && !filter) {
  //     fetchVisits();
  //   }
  // }, [tabValue]);

  const formatDateTime = (inputDateString) => {
    const inputDate = new Date(inputDateString);
    if (isNaN(inputDate.getTime())) {
      return 'Invalid Date';
    }
    const year = inputDate.getUTCFullYear();
    const month = String(inputDate.getUTCMonth() + 1).padStart(2, '0');
    const day = String(inputDate.getUTCDate()).padStart(2, '0');
    const hours = String(inputDate.getUTCHours()).padStart(2, '0');
    const minutes = String(inputDate.getUTCMinutes()).padStart(2, '0');
    const seconds = String(inputDate.getUTCSeconds()).padStart(2, '0');
    const formattedDateString = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    return formattedDateString;
  }

  const formatTimeStamp = (timestampFromDB) => {
    const options = {
      timeZone: 'Asia/Kolkata',
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      hour12: true,  // Use 12-hour clock
    };
    const formattedDate = new Date(timestampFromDB).toLocaleString('en-US', options);
    return formattedDate;
  };

  // const attendanceStatusDropdown = async () => {
  //   setLoading(true);
  //   let results = await window.Platform.database.getAllAttendanceConfigs();
  //   if (results?.status) {
  //     setAttendanceStatusData(results?.data);
  //     // setLoading(false);
  //   }
  //   else {
  //     setLoading(false);
  //   }
  // }

  const fetchVisits = async () => {
    setLoading(true);
    try {
      if (tabValue == 0) {
        let data = {
          recordPerPage: paginationModel.pageSize,
          pageNumber: paginationModel.page,
          user_name: rm,
          rsm: userData?.role == 'rsm' ? userData?.id : rsm,
          asm: userData?.role == 'asm' ? userData?.id : asm,
          // startDate: startDate,
          // endDate: endDate,
          startDate: startDate != '' ? startDate : filteredDate?.startDate,
          endDate: endDate != '' ? endDate : filteredDate?.endDate,
          Attendence_status: attendanceStatus
        }
        let results = await window.Platform.database.getAttendanceOfAllPunchedIn(data);
        if (results?.status) {
          setRowCount(results.data1);
          const jsonArrayWithId = results?.data?.map((obj, index) => ({ ...obj, id: index + 1 }));
          await setAccessChanges(jsonArrayWithId);
          setDataGrid(jsonArrayWithId);
          setLoading(false);
        }
        else {
          setLoading(false);
          window.NotificationUtils.showError("Error Fetching Data");
        }
      }
      else if (tabValue == 1) {
        let data = {
          recordPerPage: paginationModel.pageSize,
          pageNumber: paginationModel.page,
          user_name: rm,
          rsm: userData?.role == 'rsm' ? userData?.id : rsm,
          asm: userData?.role == 'asm' ? userData?.id : asm,
          // startDate: startDate,
          // endDate: endDate,
          startDate: startDate != '' ? startDate : filteredDate?.startDate,
          endDate: endDate != '' ? endDate : filteredDate?.endDate,
          Attendence_status: attendanceStatus
        }
        let results = await window.Platform.database.getAttendanceOfAllNotPunchedIn(data);
        if (results?.status) {
          setRowCount(results.data1);
          const jsonArrayWithId = results?.data?.map((obj, index) => ({ ...obj, id: index + 1 }));
          await setAccessChanges(jsonArrayWithId);
          setDataGrid(jsonArrayWithId);
          setLoading(false);
        }
        else {
          setLoading(false);
          window.NotificationUtils.showError("Error Fetching Data");
        }
      }
      else if (tabValue == 2) {
        let data = {
          recordPerPage: paginationModel.pageSize,
          pageNumber: paginationModel.page,
          user_name: rm,
          rsm: userData?.role == 'rsm' ? userData?.id : rsm,
          asm: userData?.role == 'asm' ? userData?.id : asm,
          // startDate: startDate,
          // endDate: endDate,
          startDate: startDate != '' ? startDate : filteredDate?.startDate,
          endDate: endDate != '' ? endDate : filteredDate?.endDate,
          Attendence_status: attendanceStatus
        }
        let results = await window.Platform.database.getAttendanceOfAllAllStaff(data);
        if (results?.status) {
          setRowCount(results.data1);
          const jsonArrayWithId = results?.data?.map((obj, index) => ({ ...obj, id: index + 1 }));
          await setAccessChanges(jsonArrayWithId);
          setDataGrid(jsonArrayWithId);
          setLoading(false);
        }
        else {
          setLoading(false);
          window.NotificationUtils.showError("Error Fetching Data");
        }
      }
    } catch (error) {
      console.error(error);
      setLoading(false);
      window.NotificationUtils.showError("Error Fetching Data");
    }
    // finally {
    //   setLoading(false)
    // }
  }

  const getAttendanceDetailsByDate = async (userId, date) => {
    setLoading(true)
    try {
      let result = await window.Platform.database.getAttendanceDetailsByDate({ userId: userId, date: date }) // Date: - 2025-05-22
      if (result?.status) {
        setAttendanceDetailsByDate(result?.data)
        setLoading(false);
      }
      else {
        setLoading(false);
        window.NotificationUtils.showError("Something went wrong")
      }
    } catch (error) {
      console.log(error);
      setLoading(false);
      window.NotificationUtils.showError("Error Fetching Data")
    }
  }

  const clearFilters = async () => {
    setLoading(true);
    setRsm("")
    setAsm("")
    setRm("")
    setIsDateRangeDisabled(false);
    setIsSessionDisabled(false);
    setSelectedSession("");
    setPaginationModel({ page: 0, pageSize: 20, });
    setAttendanceStatus("")
    setRsms(allUsers?.filter((ele) => ele.role.toLowerCase() === 'rsm'));
    setRms(allUsers?.filter((ele) => ele.role.toLowerCase() === 'se'));
    setAsms(allUsers?.filter((ele) => ele.role.toLowerCase() === 'asm'));
    const yesterday = new Date();
    yesterday.setDate(yesterday.getDate() - 1);
    let formatted = yesterday.toISOString().split("T")[0];
    setStartDate(formatted);
    setEndDate(formatted);
    setAccessChanges([]);
    setDataGrid([]);
    setRowCount(0);
    setLoading(false);
  }

  const downloadAttendanceExcelAllPunchedIn = async () => {
    setLoading(true);
    try {
      let data = {
        // fromDate: startDate,
        // toDate: endDate,
        fromDate: startDate != '' ? startDate : filteredDate?.startDate,
        toDate: endDate != '' ? endDate : filteredDate?.endDate,
        user_name: rm,
        Attendence_status: attendanceStatus,
        rsm: userData?.role == 'rsm' ? userData?.id : rsm,
        asm: userData?.role == 'asm' ? userData?.id : asm
      }
      let result = await window.Platform.database.exportData("attendance/downloadAttendanceExcelAllPunchedIn",
        data
      )
      const blob = new Blob([result.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const now = new Date();
      const formattedDate = `${now.getDate().toString().padStart(2, '0')}-${(now.getMonth() + 1).toString().padStart(2, '0')}-${now.getFullYear()}`;
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `PunchedIn_Attendance_Report_${formattedDate}.xlsx`);
      // link.setAttribute("download", "attendance.xlsx");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error("Export error:", error);
    }
  }

  const downloadAttendanceExcelAllNotPunchedIn = async () => {
    setLoading(true);
    try {
      let data = {
        // fromDate: startDate,
        // toDate: endDate,
        fromDate: startDate != '' ? startDate : filteredDate?.startDate,
        toDate: endDate != '' ? endDate : filteredDate?.endDate,
        user_name: rm,
        Attendence_status: attendanceStatus,
        rsm: userData?.role == 'rsm' ? userData?.id : rsm,
        asm: userData?.role == 'asm' ? userData?.id : asm
      }
      let result = await window.Platform.database.exportData("attendance/downloadAttendanceExcelAllNotPunchedIn",
        data
      )
      const blob = new Blob([result.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const now = new Date();
      const formattedDate = `${now.getDate().toString().padStart(2, '0')}-${(now.getMonth() + 1).toString().padStart(2, '0')}-${now.getFullYear()}`;
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `Not_PunchedIn_attendance_Report_${formattedDate}.xlsx`);
      // link.setAttribute("download", "attendance.xlsx");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error("Export error:", error);
    }
  }

  const downloadAttendanceExcelAllStaff = async () => {
    setLoading(true);
    try {
      let data = {
        // fromDate: startDate,
        // toDate: endDate,
        fromDate: startDate != '' ? startDate : filteredDate?.startDate,
        toDate: endDate != '' ? endDate : filteredDate?.endDate,
        user_name: rm,
        Attendence_status: attendanceStatus,
        rsm: userData?.role == 'rsm' ? userData?.id : rsm,
        asm: userData?.role == 'asm' ? userData?.id : asm
      }
      let result = await window.Platform.database.exportData("attendance/downloadAttendanceExcelAllStaff",
        data
      )
      const blob = new Blob([result.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const now = new Date();
      const formattedDate = `${now.getDate().toString().padStart(2, '0')}-${(now.getMonth() + 1).toString().padStart(2, '0')}-${now.getFullYear()}`;
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `AllStaff_Attendance_Report_${formattedDate}.xlsx`);
      // link.setAttribute("download", "attendance.xlsx");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error("Export error:", error);
    }
  }

  const fetchAccessModules = async () => {
    try {
      setLoading(true);
      let data = {
        pageNumber: paginationModel.page,
        recordPerPage: paginationModel.pageSize,
        userId: userData?.id,
        moduleId: "3mcEyrlAXj"
      }
      let results = await window.Platform.database.fetchAccessModules(data);
      if (results?.status) {
        window.NotificationUtils.showError(results?.message || "Something went wrong");
        setLoading(false);
        return;
      }
      else {
        const jsonArrayWithId = results?.data?.map((obj, index) => ({ ...obj, idIndex: index + 1 }));
        setAccessModulesData(jsonArrayWithId);
      }
    } catch (error) {
      console.error(error);
    }
    finally {
      setLoading(false)
    }
  }


  async function getAllUsers() {
    let results = await window.Platform.database.fetchEmployees()
    if (results?.status) {
      window.NotificationUtils.showError(results.message);
      setLoading(false);
      return;
    }
    else {
      setAllUsers(results?.data)
      setRsms(results?.data?.filter((ele) => ele.role.toLowerCase() == 'rsm'))
      setRms(results?.data?.filter((ele) => ele.role.toLowerCase() == 'se'))
      setAsms(results?.data?.filter((ele) => ele.role.toLowerCase() == 'asm'))
      setLoading(false);
    }
  }

  async function getUsers(role, id) {
    setLoading(true);
    if (id != "") {
      let results = await window.Platform.database.getUsersBasedOnManager({ userId: id })
      if (role == 'rsm') {
        setAsms(results?.data)
        setRms(results?.data1)
      }
      if (role == 'asm') {
        setRms(results?.data)
      }
      setLoading(false);
    } else {
      if (role == 'rsm') {
        setRm("")
        setAsm("")
        setRms(allUsers?.filter((ele) => ele.role == 'se'))
        setAsms(allUsers?.filter((ele) => ele.role == 'asm'))
      }
      if (role == 'asm') {
        setRm("")
        setRms(allUsers?.filter((ele) => ele.role == 'se'))
      }
      setLoading(false);
    }
  }

  const handleOpenModal = (data) => {
    console.log("datawewew", data)
    setViewVisitDetails(data)
    let formatDate = data?.CreatedAt.split("T")
    getAttendanceDetailsByDate(data?.userId, formatDate[0])
    setOpenModal(true);
  };

  const handleOpenModal1 = (data) => {
    console.log("datawewew", data)
    setViewVisitDetails(data)
    const [day, month, year] = data?.date?.split("-");
    const jsDate = new Date(`${year}-${month}-${day}`);

    // subtract 1 day
    jsDate.setDate(jsDate.getDate());

    const formattedDate = jsDate.toISOString().split("T")[0];
    console.log(formattedDate);
    // let formatDate = data?.date ? data?.date.split("T") : data?.date
    getAttendanceDetailsByDate(data?.userId, formattedDate);
    setOpenModal(true);
  };
  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const getEmployeeColumns = () => {
    const stringOperators = getGridStringOperators().filter((op => ['contains'].includes(op.value)));
    let result = [
      {
        field: "name",
        headerName: "Employee Name",
        sortable: false,
        width: 250,
        filterOperators: stringOperators,
        editable: false,
        renderCell: (params) => {
          let name = params.row?.name?.split(" ")
            .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()) // Capitalize each word
            .join(" ") || "N/A";
          return (
            <Tooltip title={name || "N/A"}>
              <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>{name || "N/A"}</Typography>
            </Tooltip>
          )
        },
      },
      {
        field: "date",
        headerName: "Date",
        sortable: false,
        width: 120,
        filterOperators: stringOperators,
        editable: false,
        renderCell: (params) => {
          let name = params.row?.attendance_date
            ? new Date(params.row?.attendance_date).toLocaleDateString('en-GB', {
              day: 'numeric',
              month: 'short',
              year: 'numeric'
            })
            : "N/A" || "N/A"
          return (
            <Tooltip title={name || "N/A"}>
              <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>{name}</Typography>
            </Tooltip>
          )
        },
      },
      {
        field: "Attendance Status",
        headerName: "Attendance Status",
        sortable: false,
        width: 170,
        filterOperators: stringOperators,
        editable: false,
        renderCell: (params) => {
          let name = params.row?.Attendence_status == "half_day" ? "Half Day" : params.row?.Attendence_status == "full_day" ? "Full Day" : params.row?.Attendence_status == "absent" ? "Absent" : params.row?.Attendence_status == "short_day" ? "Short Day" : params.row?.Attendence_status == "leave" ? "Leave" : "N/A" || "N/A"
          return (
            <Tooltip title={name || "N/A"}>
              <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>{name || "N/A"}</Typography>
            </Tooltip>
          )
        },
      },
      {
        field: "Total Work Time",
        headerName: "Total Work Time",
        width: 160, filterable: false,
        sortable: false,
        renderCell: (params) => {
          const time = params.row?.total_time;
          if (!time || !time.includes(":")) {
            return <Typography variant="inherit">N/A</Typography>;
          }
          const [hours, minutes] = time.split(":");
          const name = `${hours}:${minutes} hrs`;
          return (
            <Tooltip title={name || "N/A"}>
              <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>{name || "N/A"}</Typography>
            </Tooltip>
          );
        }
      },
      {
        field: "Total Distance",
        headerName: "Total Distance",
        width: 140, filterable: false,
        sortable: false,
        renderCell: (params) => {
          const name = params.row?.total_distance != null ? Number(params.row.total_distance).toFixed(2) : "N/A";
          return (
            <Tooltip title={name + "KM" || "N/A"}>
              <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>{name + "KM" || "N/A"}</Typography>
            </Tooltip>
          );
        }
      },
      {
        field: "System generated distance",
        headerName: "System Generated Distance",
        width: 210, filterable: false,
        sortable: false,
        renderCell: (params) => {
          // const name = params.row?.systemGeneratedDistance != null  ? Number(params.row.systemGeneratedDistance).toFixed(2) : "N/A";
          // const val = params.row?.systemGeneratedDistance;
          // const name = !isNaN(val) && val !== null && val !== undefined
          //   ? Number(val).toFixed(2)
          //   : "N/A";
          const val = params.row?.systemGeneratedDistance;
          const isNumber = val !== null && val !== undefined && !isNaN(val);

          const name = isNumber ? Number(val).toFixed(2) : "N/A";
          const displayValue = isNumber ? `${name} KM` : "N/A";
          return (
            <Tooltip title={displayValue || "N/A"}>
              <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>{displayValue || "N/A"}</Typography>
            </Tooltip>
          );
        }
      },
      {
        field: "View",
        headerName: "View",
        minWidth: 150,
        sortable: false,
        renderCell: (params) => {
          return (
            <>
              <Tooltip>
                <span>
                  <Button
                    variant="contained"
                    size="small"
                    onClick={() => handleOpenModal(params.row)}
                    sx={{ minWidth: "80px" }}
                  >
                    {"View"}
                  </Button>
                </span>
              </Tooltip>
              <Modal open={openModal} onClose={handleCloseModal}>
                <Box
                  sx={{
                    position: "fixed",
                    width: "100%",
                    bgcolor: "white",
                    boxShadow: 24,
                    p: 1,
                    borderRadius: 2,
                    maxHeight: "90%",
                    overflow: "auto",
                  }}
                >
                  <Typography variant="h6" className="text-center mb-4">
                    <span style={{ fontSize: "16px", fontWeight: "700" }}>{viewVisitDetails?.name} :</span> <span> (  {attendanceDetailsByDate?.attendanceSummary?.CreatedAt
                      ? new Date(attendanceDetailsByDate?.attendanceSummary?.CreatedAt).toLocaleDateString('en-GB', {
                        day: 'numeric',
                        month: 'short',
                        year: 'numeric'
                      })
                      : ""} )
                    </span>
                  </Typography>
                  <div className="table-responsive">
                    <table className="table table-bordered table-striped table-sm mb-0" style={{ width: "100%", tableLayout: "auto", whiteSpace: "nowrap" }} >
                      <thead className="table table-bordered ">
                        <tr>
                          <th className="text-dark bg-white text-center">S.No</th>
                          <th className="text-dark bg-white text-center">In Time</th>
                          <th className="text-dark bg-white text-center">In KM</th>
                          <th className="text-dark bg-white text-center">Out Time</th>
                          <th className="text-dark bg-white text-center">Out KM</th>
                          <th className="text-dark bg-white text-center">Duration (In hrs)</th>
                          <th className="text-dark bg-white text-center">Distance (In KM)</th>
                          <th className="text-dark bg-white text-center">Original Distance (In KM)</th>
                          <th className="text-dark bg-white text-center">In Address</th>
                          <th className="text-dark bg-white text-center">Out Address</th>
                          {/* <th className="text-dark bg-white text-center">In Lat Long</th>
                          <th className="text-dark bg-white text-center">Out Lat Long</th> */}
                          <th className="text-dark bg-white text-center">In - Out Images</th>
                        </tr>
                      </thead>
                      <tbody>
                        {(attendanceDetailsByDate?.inOutHistory?.length > 0) ? (
                          attendanceDetailsByDate?.inOutHistory?.map((data, index) => (
                            <tr key={index}>
                              <td className="text-center">{index + 1 || 0}</td>
                              <td className="text-center">{data?.in_time?.slice(11) || "N/A"}</td>
                              <td className="text-center">{data?.in_km || "N/A"}</td>
                              <td className="text-center">{data?.out_time?.slice(11) || "N/A"}</td>
                              <td className="text-center">{data?.out_km || "N/A"}</td>
                              <td className="text-center">{data?.duration || "N/A"}</td>
                              <td className="text-center">{data?.distance || "N/A"}</td>
                              <td className="text-center">{data?.haversine_distance_km || "N/A"}</td>
                              <td className="text-center" style={{ maxWidth: 220, wordBreak: "break-word", whiteSpace: "pre-line" }}>
                                {data?.in_address?.length > 100
                                  ? data?.in_address.replace(/(.{100})/g, "$1\n")
                                  : data?.in_address || "N/A"}
                              </td>
                              <td className="text-center" style={{ maxWidth: 180, wordBreak: "break-word", whiteSpace: "pre-line" }}>
                                {data?.out_address?.length > 100
                                  ? data?.out_address.replace(/(.{100})/g, "$1\n")
                                  : data?.out_address || "N/A"}
                              </td>
                              {/* <td className="text-center">{data?.in_address || "N/A"}</td>
                              <td className="text-center">{data?.out_address || "N/A"}</td> */}
                              {/* <td className="text-center">{`${data?.in_latitude}, ${data?.in_longitude}` || "N/A"}</td>
                              <td className="text-center">{`${data?.out_latitude}, ${data?.out_longitude}` || "N/A"}</td> */}
                              <td className="text-center">{<>
                                <Tooltip title="Click to view start image">
                                  <IconButton
                                    variant="extended"
                                    disabled={!data?.in_image}
                                    color="primary"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      openPackaging(data?.in_image);
                                    }}
                                  >
                                    <RemoveRedEyeIcon />
                                  </IconButton>
                                </Tooltip>
                                <Tooltip title="Click to view end image">
                                  <IconButton
                                    variant="extended"
                                    disabled={!data?.out_image}
                                    color="primary"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      openPackaging(data?.out_image);
                                    }}
                                  >
                                    <RemoveRedEyeIcon />
                                  </IconButton>
                                </Tooltip></>}</td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td className="text-center" style={{ fontSize: "16px", color: "blcak", fontWeight: "700" }} colSpan="11">No Data found</td>
                          </tr>
                        )}
                      </tbody>

                    </table>
                  </div>
                  <Box mt={2} display="flex" justifyContent="flex-end">
                    <Button onClick={handleCloseModal} variant="contained" color="primary">
                      Close
                    </Button>
                  </Box>
                </Box>
              </Modal>
            </>
          );
        },
      },
    ];
    return result
  }
  const getColumns1 = () => {
    const stringOperators = getGridStringOperators().filter((op => ['contains'].includes(op.value)));
    let result = [
      {
        field: "name",
        headerName: "Name",
        sortable: false,
        width: 220,
        filterOperators: stringOperators,
        editable: false,
        renderCell: (params) => {
          let name = params.row?.rm_name || "N/A";
          return (
            <Tooltip title={name || "N/A"}>
              <Typography variant="inherit" sx={{ color: "black", fontSize: "11px", fontWeight: "500" }}>{name || "N/A"}</Typography>
            </Tooltip>
          )
        },
      },
      {
        field: "userName",
        headerName: "User Name",
        sortable: false,
        width: 150,
        filterOperators: stringOperators,
        editable: false,
        renderCell: (params) => {
          let name = params.row?.userName
          return (
            <Tooltip title={name || "N/A"}>
              <Typography variant="inherit" sx={{ color: "black", fontSize: "11px", fontWeight: "500" }}>{name || "N/A"}</Typography>
            </Tooltip>
          )
        },
      },
      {
        field: "reportinM",
        headerName: "Reporting Manger",
        sortable: false,
        width: 170,
        filterOperators: stringOperators,
        editable: false,
        renderCell: (params) => {
          let name = params.row?.reportingManagerName
          return (
            <Tooltip title={name || "N/A"}>
              <Typography variant="inherit" sx={{ color: "black", fontSize: "11px", fontWeight: "500" }}>{name || "N/A"}</Typography>
            </Tooltip>
          )
        },
      },
      {
        field: "mobNo",
        headerName: "Mobile Number",
        sortable: false,
        width: 150,
        filterOperators: stringOperators,
        editable: false,
        renderCell: (params) => {
          let name = params.row?.mobno
          return (
            <Tooltip title={name || "N/A"}>
              <Typography variant="inherit" sx={{ color: "black", fontSize: "11px", fontWeight: "500" }}>{name || "N/A"}</Typography>
            </Tooltip>
          )
        },
      },
      {
        field: "email1",
        headerName: "Email",
        sortable: false,
        width: 200,
        filterOperators: stringOperators,
        editable: false,
        renderCell: (params) => {
          let name = params.row?.email
          return (
            <Tooltip title={name || "N/A"}>
              <Typography variant="inherit" sx={{ color: "black", fontSize: "11px", fontWeight: "500" }}>{name || "N/A"}</Typography>
            </Tooltip>
          )
        },
      },
      {
        field: "area",
        headerName: "Area",
        sortable: false,
        width: 100,
        filterOperators: stringOperators,
        editable: false,
        renderCell: (params) => {
          let name = params.row?.area
          return (
            <Tooltip title={name || "N/A"}>
              <Typography variant="inherit" sx={{ color: "black", fontSize: "11px", fontWeight: "500" }}>{name || "N/A"}</Typography>
            </Tooltip>
          )
        },
      },
      {
        field: "rem",
        headerName: "Remark",
        sortable: false,
        width: 100,
        filterOperators: stringOperators,
        editable: false,
        renderCell: (params) => {
          let name = params.row?.remark
          return (
            <Tooltip title={name || "N/A"}>
              <Typography variant="inherit" sx={{ color: "black", fontSize: "11px", fontWeight: "500" }}>{name || "N/A"}</Typography>
            </Tooltip>
          )
        },
      },
    ];
    return result
  };

  const getColumns2 = () => {
    const stringOperators = getGridStringOperators().filter((op => ['contains'].includes(op.value)));
    let result = [
      {
        field: "name",
        headerName: "Name",
        sortable: false,
        width: 220,
        filterOperators: stringOperators,
        editable: false,
        renderCell: (params) => {
          let name = params.row?.rm_name || "N/A";
          return (
            <Tooltip title={name || "N/A"}>
              <Typography variant="inherit" sx={{ color: "black", fontSize: "11px", fontWeight: "500" }}>{name || "N/A"}</Typography>
            </Tooltip>
          )
        },
      },
      {
        field: "userName",
        headerName: "User Name",
        sortable: false,
        width: 150,
        filterOperators: stringOperators,
        editable: false,
        renderCell: (params) => {
          let name = params.row?.userName
          return (
            <Tooltip title={name || "N/A"}>
              <Typography variant="inherit" sx={{ color: "black", fontSize: "11px", fontWeight: "500" }}>{name || "N/A"}</Typography>
            </Tooltip>
          )
        },
      },
      {
        field: "reportinM",
        headerName: "Reporting Manger",
        sortable: false,
        width: 170,
        filterOperators: stringOperators,
        editable: false,
        renderCell: (params) => {
          let name = params.row?.reportingManagerName
          return (
            <Tooltip title={name || "N/A"}>
              <Typography variant="inherit" sx={{ color: "black", fontSize: "11px", fontWeight: "500" }}>{name || "N/A"}</Typography>
            </Tooltip>
          )
        },
      },
      {
        field: "mobNo",
        headerName: "Mobile Number",
        sortable: false,
        width: 150,
        filterOperators: stringOperators,
        editable: false,
        renderCell: (params) => {
          let name = params.row?.mobno
          return (
            <Tooltip title={name || "N/A"}>
              <Typography variant="inherit" sx={{ color: "black", fontSize: "11px", fontWeight: "500" }}>{name || "N/A"}</Typography>
            </Tooltip>
          )
        },
      },
      {
        field: "email1",
        headerName: "Email",
        sortable: false,
        width: 200,
        filterOperators: stringOperators,
        editable: false,
        renderCell: (params) => {
          let name = params.row?.email
          return (
            <Tooltip title={name || "N/A"}>
              <Typography variant="inherit" sx={{ color: "black", fontSize: "11px", fontWeight: "500" }}>{name || "N/A"}</Typography>
            </Tooltip>
          )
        },
      },
      {
        field: "area",
        headerName: "Area",
        sortable: false,
        width: 100,
        filterOperators: stringOperators,
        editable: false,
        renderCell: (params) => {
          let name = params.row?.area
          return (
            <Tooltip title={name || "N/A"}>
              <Typography variant="inherit" sx={{ color: "black", fontSize: "11px", fontWeight: "500" }}>{name || "N/A"}</Typography>
            </Tooltip>
          )
        },
      },
      // {
      //     field: "View",
      //     headerName: "View",
      //     minWidth: 140,
      //     sortable: false,
      //     renderCell: (params) => {
      //         return (
      //             <>
      //                 <Tooltip>
      //                     <span>
      //                         <Button
      //                             variant="contained"
      //                             size="small"
      //                             // onClick={() => handleOpenViewModal(params.row)}
      //                             sx={{ minWidth: "80px" }}
      //                         >
      //                             {"View"}
      //                         </Button>
      //                     </span>
      //                 </Tooltip>
      //                 <Modal 
      //                 // open={openViewModal} 
      //                 // onClose={handleCloseViewModal}
      //                 >
      //                     <Box
      //                         sx={{
      //                             position: "absolute",
      //                             top: "50%",
      //                             left: "50%",
      //                             transform: "translate(-50%, -50%)",
      //                             width: "80%",
      //                             maxWidth: 900,
      //                             bgcolor: "white",
      //                             boxShadow: 24,
      //                             p: 4,
      //                             borderRadius: 2,
      //                             maxHeight: "90%",
      //                             overflowY: "auto",
      //                         }}
      //                     >
      //                         <Typography variant="h6" component="h2" mb={5} style={{ textAlign: "center" }}>
      //                             Allowances
      //                         </Typography>
      //                            <div className="row mb-3 mt-2">
      //                             <div className="col-md-6">
      //                                 <b>Name :</b> {modalData?.rm_name || "N/A"}
      //                             </div>
      //                             <div className="col-md-6">
      //                                 <b>User Name :</b> {modalData?.userName || "N/A"}
      //                             </div>
      //                         </div>
      //                            <div className="row mb-3 mt-2">
      //                             <div className="col-md-6">
      //                                 <b>Reporting Manager :</b> {modalData?.reportingManagerName || "N/A"}
      //                             </div>
      //                             <div className="col-md-6">
      //                                 <b>Mobile Number :</b> {modalData?.mobno || "N/A"}
      //                             </div>
      //                         </div>
      //                            <div className="row mb-3 mt-2">
      //                             <div className="col-md-6">
      //                                 <b>Area :</b> {modalData?.area || "N/A"}
      //                             </div>
      //                             <div className="col-md-6">
      //                                 <b>Email :</b> {modalData?.email || "N/A"}
      //                             </div>
      //                         </div>
      //                         <div className="row mb-3 mt-2">
      //                             <div className="col-md-6">
      //                                 <b>Remark :</b> {modalData?.remark || "N/A"}
      //                             </div>
      //                             <div className="col-md-6">
      //                                 <b>Start Time :</b> {modalData?.in_time?.slice(11) || "N/A"}
      //                             </div>
      //                         </div>

      //                         <div className="row mb-3">
      //                             <div className="col-md-6">
      //                                 <b>Start KM :</b> {modalData?.in_km || "N/A"}
      //                             </div>
      //                             <div className="col-md-6">
      //                                 <b>In Manual Reading :</b> {modalData?.in_manual_reading === 0 ? "No" : "Yes"}
      //                             </div>
      //                         </div>

      //                         <div className="row mb-3">
      //                             <div className="col-md-6">
      //                                 <b>End Time :</b> {modalData?.out_time?.slice(11) || "N/A"}
      //                             </div>
      //                             <div className="col-md-6">
      //                                 <b>End KM :</b> {modalData?.out_km || "N/A"}
      //                             </div>
      //                         </div>

      //                         <div className="row mb-3">
      //                             <div className="col-md-6">
      //                                 <b>Out Manual Reading :</b> {modalData?.out_manual_reading === 0 ? "No" : "Yes"}
      //                             </div>
      //                             <div className="col-md-6">
      //                                 <b>Distance :</b> {modalData?.distance || "N/A"}
      //                             </div>
      //                         </div>

      //                         <div className="row mb-3">
      //                             <div className="col-md-6">
      //                                 <b>Start Lat Long :</b>{" "}
      //                                 {modalData?.in_latitude && modalData?.in_longitude
      //                                     ? `${modalData.in_latitude}, ${modalData.in_longitude}`
      //                                     : "N/A"}
      //                             </div>
      //                             <div className="col-md-6">
      //                                 <b>End Lat Long :</b>{" "}
      //                                 {modalData?.out_latitude && modalData?.out_longitude
      //                                     ? `${modalData.out_latitude}, ${modalData.out_longitude}`
      //                                     : "N/A"}
      //                             </div>
      //                         </div>

      //                         <div className="row mb-3">
      //                             <div className="col-md-6">
      //                                 <b>In Image :</b>
      //                                 {modalData?.in_image ? (
      //                                     <Button
      //                                         size="small"
      //                                         onClick={() => openPackaging(modalData.in_image)}
      //                                         variant="outlined"
      //                                         sx={{ ml: 1 }}
      //                                     >
      //                                         View
      //                                     </Button>
      //                                 ) : (
      //                                     " N/A"
      //                                 )}
      //                             </div>
      //                             <div className="col-md-6">
      //                                 <b>Out Image :</b>
      //                                 {modalData?.out_image ? (
      //                                     <Button
      //                                         size="small"
      //                                         onClick={() => openPackaging(modalData.out_image)}
      //                                         variant="outlined"
      //                                         sx={{ ml: 1 }}
      //                                     >
      //                                         View
      //                                     </Button>
      //                                 ) : (
      //                                     " N/A"
      //                                 )}
      //                             </div>
      //                         </div>

      //                         <Box mt={2} display="flex" justifyContent="flex-end">
      //                             <Button
      //                             //  onClick={handleCloseViewModal} 
      //                             variant="contained" color="primary">
      //                                 Close
      //                             </Button>
      //                         </Box>
      //                     </Box>
      //                 </Modal>
      //             </>
      //         );
      //     },
      // },
      {
        field: "View",
        headerName: "View",
        minWidth: 150,
        sortable: false,
        renderCell: (params) => {
          return (
            <>
              <Tooltip>
                <span>
                  <Button
                    variant="contained"
                    size="small"
                    onClick={() => handleOpenModal1(params.row)}
                    sx={{ minWidth: "80px" }}
                  >
                    {"View"}
                  </Button>
                </span>
              </Tooltip>
              <Modal open={openModal} onClose={handleCloseModal}>
                <Box
                  sx={{
                    position: "fixed",
                    width: "100%",
                    bgcolor: "white",
                    boxShadow: 24,
                    p: 1,
                    borderRadius: 2,
                    maxHeight: "90%",
                    overflow: "auto",
                  }}
                >
                  <Typography variant="h6" className="text-center mb-4">
                    <span style={{ fontSize: "16px", fontWeight: "700" }}>{viewVisitDetails?.rm_name} :</span> <span> (  {params.row.date || ""} )
                    </span>
                  </Typography>
                  <div className="table-responsive">
                    <table className="table table-bordered table-striped table-sm mb-0" style={{ width: "100%", tableLayout: "auto", whiteSpace: "nowrap" }} >
                      <thead className="table table-bordered ">
                        <tr>
                          <th className="text-dark bg-white text-center">S.No</th>
                          <th className="text-dark bg-white text-center">In Time</th>
                          <th className="text-dark bg-white text-center">In KM</th>
                          <th className="text-dark bg-white text-center">Out Time</th>
                          <th className="text-dark bg-white text-center">Out KM</th>
                          <th className="text-dark bg-white text-center">Duration (In hrs)</th>
                          <th className="text-dark bg-white text-center">Distance (In KM)</th>
                          <th className="text-dark bg-white text-center">Original Distance (In KM)</th>
                          <th className="text-dark bg-white text-center">In Address</th>
                          <th className="text-dark bg-white text-center">Out Address</th>
                          {/* <th className="text-dark bg-white text-center">In Lat Long</th>
                          <th className="text-dark bg-white text-center">Out Lat Long</th> */}
                          <th className="text-dark bg-white text-center">In - Out Images</th>
                        </tr>
                      </thead>
                      <tbody>
                        {(attendanceDetailsByDate?.inOutHistory?.length > 0) ? (
                          attendanceDetailsByDate?.inOutHistory?.map((data, index) => (
                            <tr key={index}>
                              <td className="text-center">{index + 1 || 0}</td>
                              <td className="text-center">{data?.in_time?.slice(11) || "N/A"}</td>
                              <td className="text-center">{data?.in_km || "N/A"}</td>
                              <td className="text-center">{data?.out_time?.slice(11) || "N/A"}</td>
                              <td className="text-center">{data?.out_km || "N/A"}</td>
                              <td className="text-center">{data?.duration || "N/A"}</td>
                              <td className="text-center">{data?.distance || "N/A"}</td>
                              <td className="text-center">{data?.haversine_distance_km || "N/A"}</td>
                              <td className="text-center" style={{ maxWidth: 220, wordBreak: "break-word", whiteSpace: "pre-line" }}>
                                {data?.in_address?.length > 100
                                  ? data?.in_address.replace(/(.{100})/g, "$1\n")
                                  : data?.in_address || "N/A"}
                              </td>
                              <td className="text-center" style={{ maxWidth: 180, wordBreak: "break-word", whiteSpace: "pre-line" }}>
                                {data?.out_address?.length > 100
                                  ? data?.out_address.replace(/(.{100})/g, "$1\n")
                                  : data?.out_address || "N/A"}
                              </td>
                              {/* <td className="text-center">{data?.in_address || "N/A"}</td>
                              <td className="text-center">{data?.out_address || "N/A"}</td> */}
                              {/* <td className="text-center">{`${data?.in_latitude}, ${data?.in_longitude}` || "N/A"}</td>
                              <td className="text-center">{`${data?.out_latitude}, ${data?.out_longitude}` || "N/A"}</td> */}
                              <td className="text-center">{<>
                                <Tooltip title="Click to view start image">
                                  <IconButton
                                    variant="extended"
                                    disabled={!data?.in_image}
                                    color="primary"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      openPackaging(data?.in_image);
                                    }}
                                  >
                                    <RemoveRedEyeIcon />
                                  </IconButton>
                                </Tooltip>
                                <Tooltip title="Click to view end image">
                                  <IconButton
                                    variant="extended"
                                    disabled={!data?.out_image}
                                    color="primary"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      openPackaging(data?.out_image);
                                    }}
                                  >
                                    <RemoveRedEyeIcon />
                                  </IconButton>
                                </Tooltip></>}</td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td className="text-center" style={{ fontSize: "16px", color: "blcak", fontWeight: "700" }} colSpan="11">No Data found</td>
                          </tr>
                        )}
                      </tbody>

                    </table>
                  </div>
                  <Box mt={2} display="flex" justifyContent="flex-end">
                    <Button onClick={handleCloseModal} variant="contained" color="primary">
                      Close
                    </Button>
                  </Box>
                </Box>
              </Modal>
            </>
          );
        },
      },
    ];
    return result
  };

  const openPackaging = (val) => {
    // window.Platform.database.funcForBaseURL()
    // const url = "http://localhost:3001/file" + val;
    const url = window.Platform.database.funcForBaseURL() + "/file" + val;
    setImageUrl(url);
    setImageModalOpen(true);
  };


  const handleChangeTab = (event, newValue) => {
    setTabValue(newValue);
  };

  function CustomToolbar() {
    return (
      <GridToolbarContainer className="d-flex justify-content-end align-items-center mr-2">
        <Typography variant="body1" className="ml-4" sx={{ color: "black", fontWeight: "500" }}>Select Page Size:&nbsp; </Typography>
        <Select
          value={paginationModel.pageSize}
          variant="outlined"
          size="small"
          onChange={(e) => { setPaginationModel({ ...paginationModel, pageSize: e.target.value }) }}
          sx={{ width: 90, fontSize: 14, fontWeight: "500", color: "black" }}
        >
          {[10, 20, 30, 50, 100].map((role) => (
            <MenuItem key={role} value={role} sx={{ color: "black", fontWeight: "500" }}>{role}</MenuItem>
          ))}
        </Select>
      </GridToolbarContainer>
    );
  }

  const onFilterChange = async (filterModel) => {
    try {
      setLoading(true);
      setFilter(true)
      if (filterModel) {
        const response = await window.Platform.database.filterAttendance({ filterField: filterModel.field, filterValue: filterModel.value, pageNumber: paginationModel.page, startDate: startDate, endDate: endDate })
        const jsonArrayWithId = response?.data?.map((obj, index) => ({ ...obj, id: index + 1 }));
        await setAccessChanges(jsonArrayWithId)
        await setRowCount(response.data1)
        setLoading(false);
      }
      else {
        const response = await window.Platform.database.filterAttendance({ filterField: "date", pageNumber: paginationModel.page, startDate: startDate, endDate: endDate })
        const jsonArrayWithId = response?.data?.map((obj, index) => ({ ...obj, id: index + 1 }));
        await setAccessChanges(jsonArrayWithId)
        await setRowCount(response.data1)
        setLoading(false);
      }
    }
    catch (err) {
      console.error(err)
      setLoading(false);
      window.NotificationUtils.showError("Error While Recieving Data Please Wait and try again");
    }
  };

  const renderContent = () => {
    return (
      <DataGridContainer style={{ height: !accessChanges?.length ? '200px' : 'auto' }}>
        <DataGrid
          className="payrollGrid"
          density="compact"
          rows={accessChanges || []}
          columns={getEmployeeColumns()}
          sx={{ color: "black", fontSize: "14px", fontWeight: "600" }}
          disableSelectionOnClick
          disableRowSelectionOnClick
          rowHeight={60}
          disableDensitySelector
          pageSizeOptions={[10]}
          // sx={{ color: "black" }}
          onFilterModelChange={(val) => {
            if (val?.items[0]?.value?.length > 0) {
              onFilterChange(val.items[0])
              setSearchTerm(val.items[0])
            } else if (!val.items[0]?.value && startDate && endDate) {
              setSearchTerm(null)
              onFilterChange()
              console.log("CHECKING...1")
            }
            else {
              fetchVisits()
              setSearchTerm(null)
              setFilter(false)
            }
          }
          }
          filterMode="server"
          apiRef={apiRef}
          rowCount={rowCount}
          paginationModel={paginationModel}
          paginationMode="server"
          onPaginationModelChange={setPaginationModel}
          getRowId={(row, index) => `${row.userId}-${row.userName}-${row?.CreatedAt}` || index}
          components={{
            Toolbar: CustomToolbar,
          }}
        />
      </DataGridContainer>
    );
  };


  const renderContent1 = () => {
    return (
      <>
        <Stack direction={"column"} spacing={2} padding={0} width={"100%"} style={{ height: !accessChanges?.length ? '200px' : 'auto' }}>
          <DataGrid
            className="payrollGrid"
            style={{ height: !dataGrid.length ? '200px' : 'auto' }}
            density="compact"
            rows={dataGrid || []}
            columns={getColumns1()}
            sx={{ color: "black", fontSize: "14px", fontWeight: "600" }}
            rowHeight={60}
            disableSelectionOnClick
            disableRowSelectionOnClick
            initialState={{
              pagination: {
                paginationModel: {
                  pageSize: 10,
                },
              },
            }}
            rowCount={rowCount}
            paginationModel={paginationModel}
            paginationMode="server"
            onPaginationModelChange={setPaginationModel}
            getRowId={(row, index) => `${row.id}-${row.userName}` || index}
            components={{
              Toolbar: CustomToolbar,
            }}
          />
        </Stack>
      </>
    )
  }

  const renderContent2 = () => {
    return (
      <>
        <Stack direction={"column"} spacing={2} padding={0} width={"100%"} style={{ height: !accessChanges?.length ? '200px' : 'auto' }}>
          <DataGrid
            className="payrollGrid"
            style={{ height: !dataGrid.length ? '200px' : 'auto' }}
            density="compact"
            rows={dataGrid || []}
            columns={getColumns2()}
            // sx={{ color: "black", fontSize: "12px", fontWeight: "600" }}
            sx={{ color: "black", fontSize: "14px", fontWeight: "600" }}
            rowHeight={60}
            disableSelectionOnClick
            disableRowSelectionOnClick
            initialState={{
              pagination: {
                paginationModel: {
                  pageSize: 10,
                },
              },
            }}
            rowCount={rowCount}
            paginationModel={paginationModel}
            paginationMode="server"
            onPaginationModelChange={setPaginationModel}
            getRowId={(row, index) => `${row.id}-${row.userName}` || index}
            components={{
              Toolbar: CustomToolbar,
            }}
          />
        </Stack>
      </>
    )
  }

  const startDay = () => {
    setAttendanceModal(true)
  }

  const endDay = () => {
    setAttendanceModal1(true)
  }

  const formatDate = async (data) => {
    setMinDate(data)
    setDateRange1(true)
    setEndDate1(null)
    setEndDate(null)
    const datePickerResponse = new Date(data.$d);
    const year = datePickerResponse.getFullYear();
    const month = String(datePickerResponse.getMonth() + 1).padStart(2, '0');
    const day = String(datePickerResponse.getDate()).padStart(2, '0');
    const formattedDate = `${year}-${month}-${day}`;
    setStartDate1(formattedDate)
    setStartDate(formattedDate)
  }
  // const finalDateRangeFilter = async (data) => {
  //   try {
  //     setLoading(true)
  //     setFilter(true)
  //     const datePickerResponse = new Date(data);
  //     const year = datePickerResponse.getFullYear();
  //     const month = String(datePickerResponse.getMonth() + 1).padStart(2, '0');
  //     const day = String(datePickerResponse.getDate()).padStart(2, '0');
  //     const formattedDate = `${year}-${month}-${day}`;
  //     if (data) {
  //       setEndDate(formattedDate)
  //       setEndDate1(formattedDate)
  //     }
  //     if (searchTerm) {
  //       const response = await window.Platform.database.filterAttendance({ filterField: searchTerm.field, filterValue: searchTerm?.value, pageNumber: paginationModel.page, startDate: startDate, endDate: data ? formattedDate : endDate })
  //       const jsonArrayWithId = response?.data?.map((obj, index) => ({ ...obj, id: index + 1 }));
  //       setAccessChanges(jsonArrayWithId)
  //       setRowCount(response.data1)
  //     }
  //     else {
  //       const response = await window.Platform.database.filterAttendance({ filterField: "date", filterValue: searchTerm?.value, pageNumber: paginationModel.page, startDate: startDate, endDate: data ? formattedDate : endDate })
  //       const jsonArrayWithId = response?.data?.map((obj, index) => ({ ...obj, id: index + 1 }));
  //       setAccessChanges(jsonArrayWithId)
  //       setRowCount(response.data1)
  //     }
  //     setLoading(false)
  //   }
  //   catch (err) {
  //     console.log(err)
  //     setLoading(false)
  //     window.NotificationUtils.showError("Error While Recieving Data Please Wait and try again");
  //     fetchVisits()
  //   }
  // }
  // const clearDateFilter = async () => {
  //   setStartDate(null)
  //   setEndDate(null)
  //   setStartDate1(null)
  //   setEndDate1(null)
  //   setDateRange1(false)
  //   if (searchTerm) {
  //     try {
  //       setLoading(true)
  //       const response = await window.Platform.database.filterAttendance({ filterField: searchTerm ? searchTerm.field : "date", filterValue: searchTerm?.value, pageNumber: paginationModel.page, startDate: '', endDate: '' })
  //       const jsonArrayWithId = response?.data?.map((obj, index) => ({ ...obj, id: index + 1 }));
  //       setAccessChanges(jsonArrayWithId)
  //       setRowCount(response.data1)
  //       setLoading(false)
  //     }
  //     catch (e) {
  //       console.log(e)
  //       window.NotificationUtils.showError("Error While Recieving Data Please Wait and try again");
  //       fetchVisits()
  //     }
  //   }
  //   else {
  //     setFilter(false)
  //     fetchVisits()
  //   }
  // }

  return (
    <>
      <StaffEditorPageContainer>
        {loading && <OpaqueLoading />}
        <HeaderContainer>
          <Box sx={{ mt: 1, width: "100%" }}>

            <Paper elevation={3}
              sx={{
                p: 2,
                mb: 2,
                width: '100%',        // takes full width of parent
                // maxWidth: '1000px',   // optional: control max width
                mx: 'auto',
                backgroundColor: "#ebf0fa"          // center it horizontally
              }}>
              {/* <div className="container-fluid" style={{ width: "100%" }}> */}
              <div className="row mb-2">
                {/* {userData?.role.includes('admin') && <div className="col-md-3">
                <Typography variant="body1">Select HO:</Typography>
                <Select value={rsm} variant="outlined" size="small" onChange={(e) => { setRsm(e.target.value); getUsers('rsm', e.target.value) }} sx={{ width: '100%', fontSize: 14 }}>
                  <MenuItem value="">All</MenuItem>
                  {rsms.map((role) => (<MenuItem key={role} value={role.id}>{role.name}</MenuItem>))}
                </Select>
              </div>} */}
                {userData?.role.includes('admin') && (
                  <div className="col-md-3">
                    <Autocomplete
                      options={rsms}
                      // getOptionLabel={(option) => option.name || ""}
                      getOptionLabel={(option) => option.name && option.username ? `${option.name} - ${option.username}` : option.name || option.username || ""}
                      value={rsms.find((role) => role.id === rsm) || null}
                      onChange={(event, value) => {
                        setRsm(value ? value.id : "");
                        setAsm("");
                        setRm("");
                        getUsers('rsm', value ? value.id : "");
                      }}
                      renderInput={(params) => (
                        <TextField
                          label="Select HO"
                          fullWidth
                          {...params}
                          // variant="outlined"
                          size="small"
                          placeholder="Select HO"
                          InputProps={{
                            ...params.InputProps,
                            style: { color: "black", fontWeight: 500 }, // <-- This styles the input text
                          }}
                          InputLabelProps={{
                            style: { color: "black", fontWeight: 500 }, // <-- This styles the label
                          }}
                        />
                      )}
                      slotProps={{
                        paper: {
                          sx: { color: "black" }
                        }
                      }}
                      isOptionEqualToValue={(option, value) => option.id === value.id}
                      sx={{ width: '100%', fontSize: 14 }}
                    />
                  </div>
                )}
                {/* {userData?.role != 'asm' && <div className="col-md-3">
                <Typography variant="body1">Select ARM:</Typography>
                <Select value={asm} variant="outlined" size="small" onChange={(e) => { setAsm(e.target.value); getUsers('asm', e.target.value) }} sx={{ width: '100%', fontSize: 14 }}>
                  <MenuItem value="">All</MenuItem>
                  {asms.map((role) => (<MenuItem key={role} value={role.id}>{role.name}</MenuItem>))}
                </Select>
              </div>} */}
                {userData?.role !== 'asm' && (
                  <div className="col-md-3">
                    <Autocomplete
                      options={asms}
                      // getOptionLabel={(option) => option.name || ""}
                      getOptionLabel={(option) => option.name && option.username ? `${option.name} - ${option.username}` : option.name || option.username || ""}
                      value={asms.find((role) => role.id === asm) || null}
                      onChange={(event, value) => {
                        setAsm(value ? value.id : "");
                        setRm("");
                        getUsers('asm', value ? value.id : "");
                      }}
                      renderInput={(params) => (
                        <TextField
                          label="Select ARM"
                          {...params}
                          // variant="outlined"
                          size="small"
                          placeholder="Select ARM"
                          InputProps={{
                            ...params.InputProps,
                            style: { color: "black", fontWeight: 500 }, // <-- This styles the input text
                          }}
                          InputLabelProps={{
                            style: { color: "black", fontWeight: 500 }, // <-- This styles the label
                          }}
                        />
                      )}
                      slotProps={{
                        paper: {
                          sx: { color: "black" }
                        }
                      }}
                      isOptionEqualToValue={(option, value) => option.id === value.id}
                      sx={{ width: '100%', fontSize: 14 }}
                    />
                  </div>
                )}
                {/* <div className="col-md-2">
                <Typography variant="body1">Select RM :</Typography>
                <Select value={rm} variant="outlined" size="small" onChange={(e) => { setRm(e.target.value); getUsers('rm', e.target.value) }} sx={{ width: '100%', fontSize: 14 }}>
                  <MenuItem value="">All</MenuItem>
                  {rms.map((role) => (<MenuItem key={role} value={role.id}>{role.name}</MenuItem>))}
                </Select>
              </div> */}
                <div className="col-md-2">
                  <Autocomplete
                    options={rms}
                    // getOptionLabel={(option) => option.name || ""}
                    getOptionLabel={(option) => option.name && option.username ? `${option.name} - ${option.username}` : option.name || option.username || ""}
                    value={rms.find((role) => role.id === rm) || null}
                    onChange={(event, value) => {
                      setRm(value ? value.id : "");
                      // getUsers('rm', value ? value.id : "");
                    }}
                    renderInput={(params) => (
                      <TextField
                        label="Select RM"
                        {...params}
                        // variant="outlined"
                        size="small"
                        placeholder="Select RM"
                        InputProps={{
                          ...params.InputProps,
                          style: { color: "black", fontWeight: 500 }, // <-- This styles the input text
                        }}
                        InputLabelProps={{
                          style: { color: "black", fontWeight: 500 }, // <-- This styles the label
                        }}
                      />
                    )}
                    slotProps={{
                      paper: {
                        sx: { color: "black" }
                      }
                    }}
                    isOptionEqualToValue={(option, value) => option.id === value.id}
                    sx={{ width: '100%', fontSize: 14, color: "black" }}
                  />
                </div>
                <div className="col-md-2">
                  <FormControl fullWidth size="small">
                    <TextField label="From Date" size="small" type="date" sx={{ color: "black", fontSize: "13px", fontWeight: 500 }} className="form-control" value={startDate} onChange={(e) => setStartDate(e.target.value)}
                      InputLabelProps={{
                        shrink: true,
                        style: { color: "black", fontSize: "13px", fontWeight: 500 }
                      }}
                      inputProps={{
                        style: { color: "black", fontSize: "13px", fontWeight: 500 }
                      }} />
                  </FormControl>
                </div>
                <div className="col-md-2">
                  <FormControl fullWidth size="small">
                    <TextField label="To Date" size="small" type="date" sx={{ color: "black", fontSize: "13px", fontWeight: 500 }} className="form-control" value={endDate} onChange={(e) => setEndDate(e.target.value)}
                      InputLabelProps={{
                        shrink: true,
                        style: { color: "black", fontSize: "13px", fontWeight: 500 }
                      }}
                      inputProps={{
                        style: { color: "black", fontSize: "13px", fontWeight: 500 }
                      }} />
                  </FormControl>
                </div>
              </div>
              <div className="row mt-3 mb-2">

                <div className="col-md-4">
                  {/* <Button sx={{ fontSize: '14px', borderRadius: '10px', backgroundColor:"#FFDB58" }} onClick={() => setOpenDialog(true)}>
                  Today's Punches Report
                </Button> */}
                  <Button
                    fullWidth
                    size="small"
                    startIcon={<img src={todayCalanerImage} alt="Today's Calendar" height={21} width={21} />}
                    sx={{
                      fontSize: '14px',
                      borderRadius: '10px',
                      fullWidth: true,
                      // backgroundColor: '#E1AD01', // deeper mustard color
                      backgroundColor: '#c99b00',
                      color: 'white', // ensure text is readable
                      '&:hover': {
                        // backgroundColor: '#c99b00', // hover effect
                        backgroundColor: '#706130',
                      }
                    }}
                    onClick={() => setOpenDialog(true)}
                  >
                    Today's Punches Report
                  </Button>
                </div>
                {/* <div className="col-md-2">
                                      <FormControl fullWidth size="small">
                                        <InputLabel
                                          sx={{ fontSize: "14px", fontWeight: "500", color: "#000" }}
                                        >
                                          Select Session
                                        </InputLabel>
                                        <Select
                                          label="Select Session"
                                          value={selectedSession}
                                          disabled={isSessionDisabled}
                                          sx={{ fontSize: "14px", fontWeight: "500", color: "#000" }}
                                          onChange={(e) => {
                                            const selected = sessions.find((item) => item.id === e.target.value);
                                            setSelectedSession(e.target.value);
                  
                                            if (selected) {
                                              // ✅ Convert UTC → IST (local date)
                                              const start = new Date(selected.startDate);
                                              const end = new Date(selected.endDate);
                  
                                              const startIST = new Date(start.getTime() + (5.5 * 60 * 60 * 1000))
                                                .toISOString()
                                                .split("T")[0];
                                              const endIST = new Date(end.getTime() + (5.5 * 60 * 60 * 1000))
                                                .toISOString()
                                                .split("T")[0];
                  
                                              setStartDate(startIST);
                                              setEndDate(endIST);
                  
                                              // ✅ Disable manual date range if session chosen
                                              setIsDateRangeDisabled(true);
                                            } else {
                                              // ✅ If cleared, re-enable date inputs
                                              setIsDateRangeDisabled(false);
                                            }
                                          }}
                  
                                        >
                                          <MenuItem value="">
                                            <em>Select Session</em>
                                          </MenuItem>
                                          {sessions.map((s) => (
                                            <MenuItem key={s.id} value={s.id}>
                                              {s.sessionName}
                                            </MenuItem>
                                          ))}
                                        </Select>
                                      </FormControl>
                                    </div> */}
                <div className="col-md-2 ">
                  <Button variant="contained" size="small" startIcon={<img src={searchIcon} alt="icon" height={"21"} width={"21"} />} color="primary" fullWidth sx={{ fontSize: '14px', borderRadius: '10px' }} onClick={() => { setFilter(true); fetchVisits() }}>
                    Find
                  </Button>
                </div>
                {/* <div className="col-md-3 mt-3">
                <FormControl fullWidth size="small">
                  <InputLabel sx={{ color: "black", fontSize: "14px", fontWeight: "500" }}>Attendance Status</InputLabel>
                  <Select label="Attendance Status" value={attendanceStatus} onChange={(e) => setAttendanceStatus(e.target.value )} variant="outlined" size="small" sx={{ width: '100%', fontSize: 14, fontWeight: "500" }}>
                    <MenuItem value="" sx={{ color: "black", fontSize: "14px", fontWeight: "500" }}>All</MenuItem>
                    {attendanceStatusData?.map((role) => (<MenuItem key={role} value={role.id} sx={{ color: "black", fontSize: "14px", fontWeight: "500" }}>{role.name}</MenuItem>))}
                  </Select>
                </FormControl>
              </div> */}
                <div className="col-md-2">
                  <Button variant="contained" startIcon={<img src={clearFilterImage} alt="icon" height={"21"} width={"21"} />} color="secondary" size="small" fullWidth sx={{ fontSize: '14px', borderRadius: '10px' }} onClick={() => clearFilters()}>
                    Clear Filters
                  </Button>
                </div>

                {accessModulesData && accessModulesData[0]?.is_download?.toLowerCase() != "no" && <div className="col-md-2">
                  {tabValue == 0 && <Button variant="contained" size="small" startIcon={<FileDownloadIcon />} color="success" fullWidth sx={{ fontSize: '14px', borderRadius: '10px' }} onClick={() => downloadAttendanceExcelAllPunchedIn()} >
                    Download
                  </Button>}
                  {tabValue == 1 && <Button variant="contained" size="small" startIcon={<FileDownloadIcon />} color="success" fullWidth sx={{ fontSize: '14px', borderRadius: '10px' }} onClick={() => downloadAttendanceExcelAllNotPunchedIn()} >
                    Download
                  </Button>}
                  {tabValue == 2 && <Button variant="contained" size="small" startIcon={<FileDownloadIcon />} color="success" fullWidth sx={{ fontSize: '14px', borderRadius: '10px' }} onClick={() => downloadAttendanceExcelAllStaff()} >
                    Download
                  </Button>}
                </div>}
              </div>
              {/* </div> */}
            </Paper>
            <Box display="flex" justifyContent="space-between" gap={2}>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                  px: 2,
                  py: 1,
                  background: "#e8f5e9",
                  border: "1px solid #a5d6a7",
                  borderLeft: "4px solid #2e7d32",
                  borderRadius: "8px",
                  boxShadow: "0 2px 6px rgba(0,0,0,0.08)",
                  width: "fit-content",
                }}
              >
                <Typography
                  sx={{
                    fontSize: "13px",
                    fontWeight: 600,
                    color: "#1b5e20",
                    letterSpacing: "0.3px",
                  }}
                >
                  Total Entries:
                </Typography>
                <Typography
                  sx={{
                    fontSize: "15px",
                    fontWeight: 700,
                    color: "#2e7d32",
                    background: "#fff",
                    px: 1.2,
                    py: 0.2,
                    borderRadius: "6px",
                    border: "1px solid #a5d6a7",
                    minWidth: "28px",
                    textAlign: "center",
                  }}
                >
                  {dataGrid?.length > 0 ? rowCount : 0 || 0}
                </Typography>
              </Box>
              {accessModulesData && accessModulesData[0]?.is_add?.toLowerCase() != "no" &&
                <Box gap={2} display={"flex"}>
                  <Button
                    variant="contained" size="small" color="primary" sx={{ height: 30, borderRadius: '10px' }}
                    onClick={() => startDay()}>
                    <Add />
                    Start Day
                  </Button>
                  <Button variant="contained" size="small" color="primary" sx={{ height: 30, borderRadius: '10px' }}
                    onClick={() => endDay()}>
                    <Add />
                    End Day
                  </Button>
                </Box>}
            </Box>
          </Box>
        </HeaderContainer>
        <TableContainer>

          {/* {renderContent()} */}
          <TabsContainer>
            <StyledTabs
              variant="fullWidth"
              value={tabValue}
              onChange={handleChangeTab}
              indicatorColor="none"
              textColor="primary"
            >
              <Tab label="Punched In" sx={{ fontSize: "15px", color: "#000", fontWeight: "600", backgroundColor: tabValue == 0 ? "#fff" : "#e6e3e3de " }} />
              <Tab label="Not Punched In" sx={{ fontSize: "15px", color: "#000", fontWeight: "600", backgroundColor: tabValue == 1 ? "#fff" : "#e6e3e3de " }} />
              <Tab label="All Staff" sx={{ fontSize: "15px", color: "#000", fontWeight: "600", backgroundColor: tabValue == 2 ? "#fff" : "#e6e3e3de " }} />
            </StyledTabs>
            {tabValue == 0 && renderContent()}
            {tabValue == 1 && renderContent1()}
            {tabValue == 2 && renderContent2()}
          </TabsContainer>
        </TableContainer>
      </StaffEditorPageContainer>
      {
        attendanceModal && <AttendanceModal onClose={() => setAttendanceModal(false)} fetchData={() => fetchVisits()} status={true} />
      }
      {
        attendanceModal1 && <AttendanceModal onClose={() => setAttendanceModal1(false)} fetchData={() => fetchVisits()} status={false} />
      }
      {openDialog && (
        <TodayPunchModal
          is_download={accessModulesData && accessModulesData[0]?.is_download?.toLowerCase() != "no" ? true : false}
          onClose={() => setOpenDialog(false)}
        />
      )}

      <Dialog open={imageModalOpen} onClose={() => setImageModalOpen(false)} maxWidth="md">
        <DialogContent sx={{ display: "flex", flexDirection: "column", alignItems: "flex-end", p: 2, position: "relative" }}>
          <IconButton aria-label="close" onClick={() => setImageModalOpen(false)} sx={{ position: "absolute", right: 8, top: 8, color: (theme) => theme.palette.grey[500], zIndex: 1 }}>
            <CloseIcon />
          </IconButton>
          <Box sx={{ width: "100%", display: "flex", justifyContent: "center", alignItems: "center", minHeight: 200, minWidth: 200, }}>
            <img src={imageUrl} alt="Attendance" style={{ maxWidth: "100%", maxHeight: "70vh", height: "auto", width: "auto", borderRadius: 8, display: "block", margin: "0 auto" }} />
          </Box>
        </DialogContent>
      </Dialog>
    </>
  );
}
